/* istanbul ignore file */
import { useBaseCrudService } from 'framework/crud';
import { useRecruitmentApi } from 'infrastructure/api';
import candidateNoteValidation from 'domain/recruiting/candidate/Timeline/note/shared/form/candidateNoteValidation';

export const UPDATE_CANDIDATE_NOTE_PERMISSION = 'FE_UPDATE_CANDIDATE_NOTE';
export const CREATE_CANDIDATE_NOTE_PERMISSION = 'CREATE_NOTE';
export const READ_CANDIDATE_NOTES_PERMISSION = 'READ_CANDIDATE_NOTES';

const useCandidateNoteService = () => {
  const { update } = useBaseCrudService({
    listResourceUrl: '/candidates/notes',
    singleResourceUrl: '/candidates/notes/:id',
    useService: useRecruitmentApi,
  });

  return {
    getValidationSchema: () => Promise.resolve(candidateNoteValidation),
    update,
  };
};

export default useCandidateNoteService;
